<template>
  <vjs-modal :name="name"
             v-bind="$options.propsData"
             icon="flaticon2-calendar-9"
             @opened="loadEntry">
    <template slot="body-content">
      <!------------------------->
      <div class="alert alert-info" role="alert">
        <h4 class="alert-heading">
          Rewind Preview!
        </h4>
      </div>
      <!------------------------->
      <b-row>
        <b-col :cols="8">
          <h5>Schedule Information:</h5>
          <ul class="clean-list">
            <li><b>Timezone:</b> {{ userTimezone || 'Unknown' }}</li>
          </ul>
          <hr>
          <h5>Event Starting {{ date_str }}:</h5>
          <ul class="clean-list">
            <li><b>Starts:</b> {{ startStr }}</li>
            <li><b>Ends:</b> {{ endStr }}</li>
          </ul>
          <hr>
          <h5>Event Configuration:</h5>
          <ul class="clean-list">
            <li><b>Source stream:</b> {{ streamName }}</li>
            <li><b>Description:</b> {{ description }}</li>
          </ul>
          <ul class="clean-list">
            <li><b>Overridden:</b> {{ isOverridden ? 'Yes' : 'No' }}</li>
          </ul>
        </b-col>
        <b-col :cols="4">
          <img class="img-fluid" :alt="imgAlt" :src="imgSrc">
        </b-col>
      </b-row>
      <edit-scheduled-entries-modal
        id="edit-scheduled-entries-modal"
        name="edit-scheduled-entries"
        :refresh-calendar="refreshCalendar"
        :full-calendar="fullCalendar"
        :entries="entries" />
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" @click="() => editThenReload(entry)">
        Edit
      </b-button>
      <b-button variant="ss-danger" @click="() => close(true)">
        Delete
      </b-button>
      <b-button variant="ss" @click="() => close(false)">
        Close
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';
import SchedulerEditMixin from 'VueMixins/SchedulerEditRewindMixin';
import EditScheduledEntriesModal from 'VueModals/EditScheduledEntriesRewindModal.vue';

export default {
  name: 'cal-event-modal',
  components: {
    VjsModal,
    EditScheduledEntriesModal,
  },
  mixins: [
    VjsModalMixin,
    SchedulerEditMixin,
  ],
  props: {
    entry: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    refreshCalendar: {
      type: Function,
      default: () => 1,
    },
    fullCalendar: {
      type: Object,
      default() {
        return {};
      },
    },
    name: {
      type: String,
      required: false,
      default: 'cal-event-modal',
    },
    startStr: {
      type: String,
      required: true,
    },
    endStr: {
      type: String,
      required: true,
    },
    streamName: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    imgSrc: {
      type: String,
      required: true,
    },
    imgAlt: {
      type: String,
      required: true,
    },
    userTimezone: {
      type: String,
      required: true,
    },
    isOverridden: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    date_str() {
      return moment(this.startStr).format("ddd Do");
    },
  },
  methods: {
    close(confirm, data) {
      this.complete({
        confirm,
        data,
      });
    },
    loadEntry() {
      this.entries = [this.entry];
    },
    async editThenReload(entry) {
      const result = await this.editScheduledEntries(entry);
      if (result) {
        this.refreshCalendar();
        this.close(true, result);
      }
    },
  },
};
</script>
